import type { Query } from '@ab-core/graphql/dist';
import { useQuery } from '@apollo/client';
import { useEffect, useState } from 'react';
import { getErrorLoggerFunction } from '../utils';
import { GET_CUSTOMER_DATANORM } from './gql/getCustomerDatanorm';

type QueryDataType = Pick<Query, 'getCustomerDatanorm'>;
type OutgoingDataType = QueryDataType['getCustomerDatanorm'];

const onError = getErrorLoggerFunction('getCustomerDatanorm');

export const useGetCustomerDatanorm = () => {
    const [outgoingData, setOutgoingData] = useState<OutgoingDataType>(undefined);

    const { data, loading, refetch, error } = useQuery<QueryDataType>(GET_CUSTOMER_DATANORM, {
        onError
    });

    useEffect(() => {
        if (data) {
            setOutgoingData(data.getCustomerDatanorm);
        }
    }, [data]);

    return {
        customerDatanorm: outgoingData,
        error: !!error,
        success: !!data,
        loading,
        refetch
    };
};
